import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, ListItem, ListItemText, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService } from "../../../../../../../../use-cases/geo-veles"
import { FixedSizeList, ListChildComponentProps } from "react-window"
import { formatCPF } from "../../../../../../../../utils"
import AutoSizer from "react-virtualized-auto-sizer"
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import { theme } from "../../../../../../../styles"

function RenderActualCPFs(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaDeduplicacao } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCPF(listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs[index] ?? '')} />
        </ListItem>
    );
}

function RenderNewCPFs(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaDeduplicacao } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCPF(listaDeduplicacao.fileListData.fileListTableValues.fileListValidData[index] ?? '')} />
        </ListItem>
    );
}

function RenderRepeatedCPFs(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaDeduplicacao } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCPF(listaDeduplicacao.fileListData.fileListTableValues.fileListRepeatedData[index] ?? '')} />
        </ListItem>
    );
}

function RenderInvalidCPFs(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaDeduplicacao } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCPF(listaDeduplicacao.fileListData.fileListTableValues.fileListInvalidData[index] ?? '')} />
        </ListItem>
    );
}

export const PreviewListaDeduplicacao = (props: {
    openPreviewListaDeduplicacao: boolean
}) => {
    // State
    const { listaDeduplicacao } = useAppSelector((state) => state)
    // Hook
    const { openPreviewListaDeduplicacao, addFileListToListaDeduplicacao, openImportFileListaDeduplicacao } = useListaDeduplicacaoService()

    return (
        <>
            {
                props.openPreviewListaDeduplicacao === true &&
                <>
                    <Dialog
                        fullWidth
                        maxWidth={'lg'}
                        open={listaDeduplicacao.openPreviewListaDeduplicacao}
                        onClose={() => {
                            openPreviewListaDeduplicacao(false)
                        }}
                    >
                        <DialogTitle>
                            <Typography fontWeight={'bold'} textTransform="uppercase" variant="h5" color='primary'>
                                Pré visualização do arquivo - <strong>{listaDeduplicacao.fileData.name}</strong>
                            </Typography>
                        </DialogTitle>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main} />
                        </Box>
                        <DialogContent>
                            <Grid container
                                height={300}
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    overflowY: 'hidden'
                                }}
                            >
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddCheckIcon sx={{ width: '8%', height: '8%' }} /> CPFs atuais:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaDeduplicacao.editListaDeduplicacaoForm.fields.CPFs.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderActualCPFs}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddIcon sx={{ width: '8%', height: '8%' }} /> CPFs novos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaDeduplicacao.fileListData.fileListTableValues.fileListValidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderNewCPFs}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <SyncProblemIcon sx={{ width: '8%', height: '8%' }} /> CPFs repetidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaDeduplicacao.fileListData.fileListTableValues.fileListRepeatedData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderRepeatedCPFs}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistRemoveIcon sx={{ width: '8%', height: '8%' }} /> CPFs inválidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaDeduplicacao.fileListData.fileListTableValues.fileListInvalidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderInvalidCPFs}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main} />
                        </Box>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    openPreviewListaDeduplicacao(false)
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    addFileListToListaDeduplicacao()
                                    openPreviewListaDeduplicacao(false)
                                    openImportFileListaDeduplicacao(false)
                                }}
                            >
                                Enviar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </>
    )
}